export const FETCH_PRODUCTION_DATA = 'FETCH_PRODUCTION_DATA';
export const FETCH_PRODUCTION_DATA_SUCCESS = 'FETCH_PRODUCTION_DATA_SUCCESS';
export const FETCH_PRODUCTION_DATA_ERROR = 'FETCH_PRODUCTION_DATA_ERROR';

export const CREATE_PRODUCTION_DATA = 'CREATE_PRODUCTION_DATA';
export const CREATE_PRODUCTION_DATA_SUCCESS = 'CREATE_PRODUCTION_DATA_SUCCESS';
export const CREATE_PRODUCTION_DATA_ERROR = 'CREATE_PRODUCTION_DATA_ERROR';

export const CREATE_PRODUCTION_DATA_BULK = 'CREATE_PRODUCTION_DATA_BULK';
export const CREATE_PRODUCTION_DATA_BULK_SUCCESS =
  'CREATE_PRODUCTION_DATA_BULK_SUCCESS';
export const CREATE_PRODUCTION_DATA_BULK_ERROR =
  'CREATE_PRODUCTION_DATA_BULK_ERROR';

export const UPDATE_PRODUCTION_DATA = 'UPDATE_PRODUCTION_DATA';
export const UPDATE_PRODUCTION_DATA_SUCCESS = 'UPDATE_PRODUCTION_DATA_SUCCESS';
export const UPDATE_PRODUCTION_DATA_ERROR = 'UPDATE_PRODUCTION_DATA_ERROR';

export const DELETE_PRODUCTION_DATA = 'DELETE_PRODUCTION_DATA';
export const DELETE_PRODUCTION_DATA_SUCCESS = 'DELETE_PRODUCTION_DATA_SUCCESS';
export const DELETE_PRODUCTION_DATA_ERROR = 'DELETE_PRODUCTION_DATA_ERROR';

export const FETCH_BASIC_PRODUCTION_DATA = 'FETCH_BASIC_PRODUCTION_DATA';
export const FETCH_BASIC_PRODUCTION_DATA_SUCCESS =
  'FETCH_BASIC_PRODUCTION_DATA_SUCCESS';
export const FETCH_BASIC_PRODUCTION_DATA_ERROR =
  'FETCH_BASIC_PRODUCTION_DATA_ERROR';
export const CREATE_BASIC_PRODUCTION_ADVANCEMENT =
  'CREATE_BASIC_PRODUCTION_ADVANCEMENT';
export const CREATE_BASIC_PRODUCTION_ADVANCEMENT_SUCCESS =
  'CREATE_BASIC_PRODUCTION_ADVANCEMENT_SUCCESS';
export const CREATE_BASIC_PRODUCTION_ADVANCEMENT_ERROR =
  'CREATE_BASIC_PRODUCTION_ADVANCEMENT_ERROR';
export const UPDATE_BASIC_PRODUCTION_ADVANCEMENT =
  'UPDATE_BASIC_PRODUCTION_ADVANCEMENT';
export const UPDATE_BASIC_PRODUCTION_ADVANCEMENT_SUCCESS =
  'UPDATE_BASIC_PRODUCTION_ADVANCEMENT_SUCCESS';
export const UPDATE_BASIC_PRODUCTION_ADVANCEMENT_ERROR =
  'UPDATE_BASIC_PRODUCTION_ADVANCEMENT_ERROR';
export const SPLIT_BASIC_PRODUCTION_ADVANCEMENT =
  'SPLIT_BASIC_PRODUCTION_ADVANCEMENT';
export const SPLIT_BASIC_PRODUCTION_ADVANCEMENT_SUCCESS =
  'SPLIT_BASIC_PRODUCTION_ADVANCEMENT_SUCCESS';
export const SPLIT_BASIC_PRODUCTION_ADVANCEMENT_ERROR =
  'SPLIT_BASIC_PRODUCTION_ADVANCEMENT_ERROR';
export const CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK =
  'CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK';
export const CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK_SUCCESS =
  'CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK_SUCCESS';
export const CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK_ERROR =
  'CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK_ERROR';
export const CREATE_FULL_PRODUCTION_ADVANCEMENT_BULK =
  'CREATE_FULL_PRODUCTION_ADVANCEMENT_BULK';
export const CREATE_FULL_PRODUCTION_ADVANCEMENT_BULK_SUCCESS =
  'CREATE_FULL_PRODUCTION_ADVANCEMENT_BULK_SUCCESS';
export const CREATE_FULL_PRODUCTION_ADVANCEMENT_BULK_ERROR =
  'CREATE_FULL_PRODUCTION_ADVANCEMENT_BULK_ERROR';
export const RESET_CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK_SUCCESS =
  'RESET_CREATE_BASIC_PRODUCTION_ADVANCEMENT_BULK_SUCCESS';
export const FETCH_CUSTOM_FIELDS = 'FETCH_CUSTOM_FIELDS';
export const FETCH_CUSTOM_FIELDS_SUCCESS = 'FETCH_CUSTOM_FIELDS_SUCCESS';
export const FETCH_CUSTOM_FIELDS_ERROR = 'FETCH_CUSTOM_FIELDS_ERROR';
export const FETCH_SETTINGS_FOR_PRODUCTION = 'FETCH_SETTINGS_FOR_PRODUCTION';
export const FETCH_SETTINGS_FOR_PRODUCTION_SUCCESS =
  'FETCH_SETTINGS_FOR_PRODUCTION_SUCCESS';
export const FETCH_SETTINGS_FOR_PRODUCTION_ERROR =
  'FETCH_SETTINGS_FOR_PRODUCTION_ERROR';
export const UPDATE_SETTINGS_FOR_PRODUCTION = 'UPDATE_SETTINGS_FOR_PRODUCTION';
export const UPDATE_SETTINGS_FOR_PRODUCTION_SUCCESS =
  'UPDATE_SETTINGS_FOR_PRODUCTION_SUCCESS';
export const UPDATE_SETTINGS_FOR_PRODUCTION_ERROR =
  'UPDATE_SETTINGS_FOR_PRODUCTION_ERROR';
